var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.602,
    d: "M16.498 4v8.87l7.497 3.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.498 4L9 16.22l7.498-3.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.602,
    d: "M16.498 21.968v6.027L24 17.616z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.498 27.995v-6.028L9 17.616z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    d: "M16.498 20.573l7.497-4.353-7.497-3.348z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.602,
    d: "M9 16.22l7.498 4.353v-7.701z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.c378096feb767dfd5337d2354cf83662.svg";
export { ForwardRef as ReactComponent };